import { FC, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

type Props = {
  href: string;
};
const Redirect: FC<Props> = ({ href }) => {
  const navigate = useNavigate();
  useEffect(() => {
    navigate(href);
  }, [navigate, href]);
  return <></>;
};

export default Redirect;
